declare global {
	interface Window {
		// tslint:disable-next-line no-any
		tarteaucitron: any;
		tarteaucitronForceLanguage: string;
	}
}

const UprezStatsKey = 'uprezStats';
const closeBannerEventName = 'tac.close_alert';
const openBannerEventName = 'tac.open_alert';

const loadTarteaucitron = () => {
	/*
		A few things to note about the tarteaucitron library:

		1) The library tarteaucitron is supposed to be initiated in <body> and a part of the init is attached to window.onload.
		We can't do that because we need to know from a config if gallApp must be gdpr compliant
		This method contains the code that is supposed to be executed after the page is loaded
		If you upgrade the tarteaucitron library, replace this code by the part attached on window.onload in the library's code.

		2) If you add new translations to project, make sure to add them to this library too.

		3) The EdgeHTML webview currently used in the windows version of the application does not allow the creation of cookies for a local domain.
		For this reason, for apps on this OS, the consent can't be stored in a cookie and should be stored in the localStorage instead.
		In commit 534286b, we modified the tarteaucitron.js file to detect if local cookies are working and using localStorage when needed.

		4) The library isn't compatible with Webpack so it is placed in public/.gallery/static/libs.
	*/
	window.tarteaucitron.load();
	window.tarteaucitron.fallback(['tarteaucitronOpenPanel'], function (elem: Element) {
		elem.addEventListener('click', function (event: Event) {
			window.tarteaucitron.userInterface.openPanel();
			event.preventDefault();
		}, false);
	}, true);
};

const initGDPR = (language: string, privacyUrl: string, onAccept: () => void) => {
	window.tarteaucitronForceLanguage = language;

	window.tarteaucitron.init({
		'privacyUrl': privacyUrl,
		'hashtag': '#tarteaucitron',
		'cookieName': 'tarteaucitron',
		'orientation': 'bottom',
		'showAlertBig': false,
		'showAlertSmall': false,
		'cookieslist': false,
		'showIcon': false,
		'iconPosition': 'BottomRight',
		'adblocker': false,
		'DenyAllCta' : true,
		'AcceptAllCta': true,
		'highPrivacy': true,
		'handleBrowserDNTRequest': false,
		'removeCredit': true,
		'moreInfoLink': false,
		'useExternalCss': false,
		'readmoreLink': privacyUrl,
		'mandatory': false,
	});

	window.tarteaucitron.services.uprezStats = {
		'key': UprezStatsKey,
		'type': 'analytic',
		'name': 'Google Analytics',
		'uri': 'https://support.google.com/analytics/answer/6004245',
		'needConsent': true,
		'cookies': ['_ga', '_gat', '_gid', '__utma', '__utmb', '__utmc', '__utmt', '__utmz'],
		'js': function () {
			'use strict';
			// When user allows service
			onAccept();
		},
	};

	(window.tarteaucitron.job = window.tarteaucitron.job || []).push(UprezStatsKey);

	loadTarteaucitron();
};

const acceptAll = () => window.tarteaucitron.userInterface.respondAll(true);
const denyAll = () => window.tarteaucitron.userInterface.respondAll(false);
const openPanel = () => window.tarteaucitron.userInterface.openPanel();

const addBannerOpenListener = (method) => window.addEventListener(openBannerEventName, method);
const addBannerCloseListener = (method) => window.addEventListener(closeBannerEventName, method);

export { initGDPR, acceptAll, denyAll, openPanel, addBannerOpenListener, addBannerCloseListener };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/GDPRApi/index.ts